import React from 'react';
import { SFEntityID } from 'utils/types';
import PropTypes from 'prop-types';
import css from './ServicesCardFooter.scss';
import { Link } from 'react-router-dom';
import { defaultScheduleLinkForService } from 'utils/scheduler';
import { getTenantConfig } from 'utils/tenant';
import ServiceCardFooterOptions from './ServiceCardFooterOptions';

export default class ServicesCardFooter extends React.Component {

  get scheduleLink(){
   return getTenantConfig('MOBILE_APPOINTMENTS_ENABLED') ?
      <Link to= {`service/${this.props.id}/schedule`} aria-label={`Schedule with ${this.props.name}`}>Schedule</Link>
     : <a href={defaultScheduleLinkForService(this.props.id)} aria-label={`Schedule with` + this.props.name}>Schedule</a>;
  }

  isSmartLinkVisible() {
     return ( this.props.displaySmartThinkingLink &&
              this.props.canMakeAppointment &&
              getTenantConfig('SMARTHINKING_LTI_ENABLED') &&
              (this.props.hasConnectLicense || this.props.canSeeStudentServices))
            || false;
  }

  get smartThinkingLink() {
    return this.isSmartLinkVisible() ?
      <a href = {`../serviceCatalog/smarthinkingLTI.html?partyId=${this.props.id}`} rel="noopener noreferrer"
         target="_blank" aria-label={`Launch Smarthinking`}>Launch Smarthinking</a>
      : null;
  }

  get scheduleButton() {
    // onlineSchedulingAvailable is true if
    // user is student AND service has a calendar enabled
    return this.props.onlineSchedulingAvailable ? this.scheduleLink : null;
  }

  get phoneButton() {
    return this.props.phoneNumber ? <a href={`tel:${this.props.phoneNumber}`} aria-label={`Call ${this.props.name}`}>Call</a> : null;
  }

  get moreOptions() {
    return (
      <ServiceCardFooterOptions
        serviceId={this.props.id}
        serviceName={this.props.name}
        email={this.props.email}
        url={this.props.url}
        serviceCalendarEnabled={this.props.serviceCalendarEnabled}
        isStaff={this.props.isStaff}
        upward
        isStudent={this.props.isStudent}
        kioskId={this.props.kioskId}
        virtualCheckInEnabled={this.props.virtualCheckInEnabled}
        checkedIntoService={this.props.checkedIntoService}
        virtualCheckInOpen={this.props.virtualCheckInOpen}
      />
    );
  }

  render() {
    return (
      <div className={css["services-card-footer"]}>
        <div className={css["services-card-footer-links"]}>
          {this.scheduleButton}
          {this.phoneButton}
          {this.smartThinkingLink}
        </div>
        {this.moreOptions}
      </div>
    );
  }
}

ServicesCardFooter.propTypes = {
  id: SFEntityID.isRequired,
  phoneNumber: PropTypes.string,
  isStaff: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  onlineSchedulingAvailable: PropTypes.bool,
  serviceCalendarEnabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  canSeeStudentServices: PropTypes.bool,
  canMakeAppointment: PropTypes.bool,
  hasConnectLicense: PropTypes.bool,
  displaySmartThinkingLink: PropTypes.bool,
  email: PropTypes.string,
  url: PropTypes.string,
  kioskId: PropTypes.number,
  virtualCheckInEnabled: PropTypes.bool,
  checkedIntoService: PropTypes.bool,
  virtualCheckInOpen: PropTypes.bool
};
